module.exports = __webpack_public_path__ + "static/media/blue-clock-alert.b31f870d.svg";